module.exports = __webpack_public_path__ + "img/logo.960db95e.svg";